import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import { clearAuthenticatedUserContext } from "../../appInsights";
import { clearLocalStorageOnSignOut } from "../upload/interruptedUpload";

const LogoutButton: React.FC = () => {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation();

  const logout = () => {
    // Everything but a message left for another account whose upload a dead session cut
    // short (AKL-891); see interruptedUpload.ts.
    clearLocalStorageOnSignOut();
    clearAuthenticatedUserContext();
    keycloak.logout({
      redirectUri: window.location.origin + "/login",
    });
  };

  return (
    // No text color of its own — inherits from the host (e.g. the header
    // menu's menuItem), which carries the light/dark variants.
    <button onClick={logout} className="w-full text-left">
      {t("Log Out")}
    </button>
  );
};

export default LogoutButton;
